import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ConfiguracionVentanilla } from 'src/app/models/configuracionVentanilla.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VentanillaUACModel } from 'src/app/models/ventanillaUAC.model';
import { TramiteUACModel } from 'src/app/models/tramiteUAC.model';
import { FuncionarioBasicoModel } from 'src/app/models/funcionario.model';
import { config } from 'rxjs';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Component({
    selector: 'app-configuracion-ventanilla',
    templateUrl: './configuracion-ventanilla.component.html',
    styleUrls: ['./configuracion-ventanilla.component.css']
})
export class ConfiguracionVentanillaComponent implements OnInit {
    modalOptionsGuardarVentanilla: any;

    sedes: DetalleDominio[];
    ventanillas: VentanillaUACModel[] = [];
    ventanillasFiltro: VentanillaUACModel[];
    funcionarios: FuncionarioBasicoModel[];
    tramites: TramiteUACModel[];

    listaTramites: any[];
    listaFuncionarios: any[];

    sede: string;
    ventanilla: string;
    tramitesSeleccionados: any[];
    funcionariosSeleccionados: any[];

    mostrarFuncionarios = true;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.listaTramites = [];
        this.listaFuncionarios = [];
        this.modalOptionsGuardarVentanilla = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MSG_CONFIRMACION_CONFIGURAR_VENTANILLA,
            'SI', 'NO', 'fas fa-save', true, false,
            'Guardar',
            null, 'btn-secondary');
        this.inicializarCampos();
        this.validarFormularioCompleto();
    }

    getFuncionariosSeleccionados(evento: any) {
        this.funcionariosSeleccionados = evento.elementosSeleccionados.filter(elemento => elemento.checked === true);
        this.validarFormularioCompleto();
    }

    getTramitesSeleccionados(evento: any) {
        this.tramitesSeleccionados = evento.elementosSeleccionados.filter(elemento => elemento.checked === true);
        this.validarFormularioCompleto();
    }

    validarFormularioCompleto() {
        this.modalOptionsGuardarVentanilla.disabled = !(
            this.utilService.validarCamposObligatorios(this.sede) &&
            this.utilService.validarCamposObligatorios(this.ventanilla) &&
            this.utilService.validarCamposObligatorios(this.funcionariosSeleccionados) && this.funcionariosSeleccionados.length > 0 &&
            this.utilService.validarCamposObligatorios(this.tramitesSeleccionados) && this.tramitesSeleccionados.length > 0
        );
        this.filtrarVentanillasPorSede();
    }

    filtrarVentanillasPorSede() {
        this.ventanillasFiltro = this.ventanillas.filter(ventanilla => ventanilla.ventanillaUacPK.sede
            === this.sede);
    }

    inicializarCampos() {
        this.obtenerDominio('Sede', 'sedes');
        this.obtenerVentanillas();
        this.obtenerTramites();
    }
    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     * @author klagos
     * @param filtro Dominio a consultar
     * @param lista Variable a la que se va a asignar el resultado
     */
    obtenerDominio(filtro, lista) {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    obtenerVentanillas() {
        this.spinner.show();
        let serviceProvider: string = 'consultarVentanillas';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['estado', DominiosService.ESTADO_CODIGO_INACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.ventanillas = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    obtenerTramites() {
        this.spinner.show();
        let serviceProvider: string = 'consultarTramites';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy', "estado=ACT"]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;
                for (let tramite of this.tramites) {
                    let obj = { id: tramite.idTramite, nombreElelemento: tramite.nombre, checked: false };
                    this.listaTramites.push(obj);
                }
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    obtenerFuncionarios(consultaSia3 : string) {
        this.desmarcarTodo();
        if (this.utilService.validarCamposObligatorios(this.sede) && this.utilService.validarCamposObligatorios(this.ventanilla)) {
            this.spinner.show();
            const serviceProvider = 'getFuncionariosRolVentanilla';
            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['sede', this.sede]);
            queryParams.push(['numeroVentanilla', this.ventanilla]);
            queryParams.push(['consultaSia3', consultaSia3 ]);
            let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
            this.global.getGenerico(url).subscribe(
                data => {
                    this.funcionarios = data;
                    for (let funcionario of this.funcionarios) {
                        let obj = { id: funcionario.numeroIdFuncionario, nombreElelemento: funcionario.nombreCompleto, checked: false };
                        this.listaFuncionarios.push(obj);
                    }
                    this.obtenerConfiguracionPrevia();
                    this.spinner.hide();
                }, err => {
                    if (consultaSia3 === 'true') {
                        this.obtenerFuncionarios('false');
                        this.alertService.generateAlertInfo('No fue posible cargar los funcionarios desde SIA3', 'Error SIA3');
                    } else {
                        this.catchException('No fue posible cargar los funcionarios desde SIA3');
                    }
                }
            );
        }
    }

    obtenerConfiguracionPrevia() {
        const serviceProvider = 'getConfiguracionPrevia';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['sede', this.sede]);
        queryParams.push(['numeroVentanilla', this.ventanilla]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                const configuraciones: ConfiguracionVentanilla[] = data;
                this.funcionariosSeleccionados = [];
                this.tramitesSeleccionados = [];
                if (configuraciones && configuraciones.length > 0) {
                    for (const configuracion of configuraciones) {
                        const funcionario = this.listaFuncionarios.find(elemento => elemento.id === configuracion.numeroIdFuncionario);
                        if (funcionario && !funcionario.checked) {
                            funcionario.checked = true;
                            this.funcionariosSeleccionados.push(funcionario);
                        }

                        const tramite = this.listaTramites.find(elemento => elemento.id === configuracion.idTramite);
                        if (tramite && !tramite.checked) {
                            tramite.checked = true;
                            this.tramitesSeleccionados.push(tramite);
                        }
                    }

                    if (this.funcionariosSeleccionados.length === 0 ) {
                        this.listaTramites.forEach(elemento => elemento.checked = false);
                        this.guardarVentanilla([true]);
                    }
                    this.validarFormularioCompleto();
                } else {
                    this.listaTramites.forEach(elemento => elemento.checked = false);
                }
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    desmarcarTodo() {
        this.mostrarFuncionarios = false;     
        this.listaFuncionarios = [];
        this.listaTramites.forEach((tramite) => {
            tramite.checked = false;
        });

        setTimeout(() => {
            this.mostrarFuncionarios = true;
        }, 100);
    }

    guardarVentanilla(evento: any[]) {
        if (evento[0]) {
            this.spinner.show();
            const datos: ConfiguracionVentanilla[] = this.crearModelosParaGuardar();
            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            if (datos.length === 0) {
                queryParams.push(['sede', this.sede]);
                queryParams.push(['numeroVentanilla', this.ventanilla]);
            }
            const serviceProvider = 'guardarConfiguracionVentanilla';
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, datos).subscribe(
                data => {
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                }, err => {
                    if (err.status == '500') {
                        this.catchException(err.error.message);
                    } else {
                        this.catchException(ConstantesService.MSG_ERROR_CONFIGURAR_VENTANILLA);
                    }
                }
            );
        }
    }

    crearModelosParaGuardar() {
        let registros: ConfiguracionVentanilla[] = [];
        for (let datosFuncionario of this.funcionariosSeleccionados) {
            let funcionario: FuncionarioBasicoModel = this.funcionarios.filter(elemento => elemento.numeroIdFuncionario === datosFuncionario.id)[0];
            for (let datosTramite of this.tramitesSeleccionados) {
                let registro: ConfiguracionVentanilla = new ConfiguracionVentanilla();
                registro.idTramite = datosTramite.id;
                registro.tipoIdFuncionario = funcionario.tipoIdFuncionario;
                registro.numeroIdFuncionario = funcionario.numeroIdFuncionario;
                registro.numeroVentanilla = this.ventanilla;
                registro.sede = this.sede;
                registros.push(registro);
            }
        }
        return registros;
    }

    actualizarValores(){
        this.ventanilla = undefined;
        this.validarFormularioCompleto();
        this.obtenerFuncionarios('true');
    }
    
    /**
     * Método de control de Excepciones
     * @function cathException
     * @param  {type} error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}
